import { render, staticRenderFns } from "./FeaturedProjects.vue?vue&type=template&id=28458a2a&scoped=true&"
import script from "./FeaturedProjects.vue?vue&type=script&lang=js&"
export * from "./FeaturedProjects.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedProjects.vue?vue&type=style&index=0&id=28458a2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28458a2a",
  null
  
)

export default component.exports